import { css } from '@emotion/react'
import { Cell, Grid } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { Fragment, ReactNode } from 'react'

import { CameraPreview } from './CameraPreview'

interface SalaEsperaVideochamadaAnfitriaoDesktopLayoutProps {
  audioEnabled: boolean
  videoEnabled: boolean
  setAudioEnabled(value: boolean): void
  setVideoEnabled(value: boolean): void
  children: ReactNode
}

export function SalaEsperaVideochamadaAnfitriaoDesktopLayout(
  props: Readonly<SalaEsperaVideochamadaAnfitriaoDesktopLayoutProps>
) {
  const { audioEnabled, videoEnabled, setAudioEnabled, setVideoEnabled, children } = props

  return (
    <Fragment>
      <PageHeaderSection title='Videochamadas e-SUS APS' />
      <PageContent>
        <Grid alignItems='center' style={styles.grid}>
          <Cell xs={12} md={5}>
            {children}
          </Cell>
          <Cell md={1} />
          <Cell xs={12} md={6}>
            <CameraPreview
              audioEnabled={audioEnabled}
              videoEnabled={videoEnabled}
              setAudioEnabled={setAudioEnabled}
              setVideoEnabled={setVideoEnabled}
            />
          </Cell>
        </Grid>
      </PageContent>
    </Fragment>
  )
}

const styles = {
  // 72px de margem inferior para o alinhamento óptico definido no protótipo
  grid: css`
    margin-bottom: 4.5rem;
  `,
}
